import tokens from '../tokens/js/tokens';
// Definition of the "active" color schema
// -----------------------------------------------------------------------------
// Mode: Light
// -----------------------------------------------------------------------------
// Light + Hard + Default
export const ACTIVE_LIGHT_HARD_DEFAULT = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.active[100].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Light + Hard + Hover
export const ACTIVE_LIGHT_HARD_HOVER = {
    background: tokens.colors.navy[900].value,
    border: tokens.colors.navy[900].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Light + Hard + Pressed
export const ACTIVE_LIGHT_HARD_PRESSED = {
    background: tokens.colors.navy[800].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Light + Hard + Focus
export const ACTIVE_LIGHT_HARD_FOCUS = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Light + Hard + Disabled
export const ACTIVE_LIGHT_HARD_DISABLED = {
    background: 'transparent',
    border: tokens.colors.navy[700].value,
    foregroundAlt: tokens.colors.navy[700].value,
    foreground: tokens.colors.navy[700].value
};
// Ligth + Soft + Default
export const ACTIVE_LIGHT_WHITE_DEFAULT = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Light + Soft + Hover
export const ACTIVE_LIGHT_WHITE_HOVER = {
    background: tokens.colors.navy[900].value,
    border: tokens.colors.navy[900].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Light + Soft + Pressed
export const ACTIVE_LIGHT_WHITE_PRESSED = {
    background: tokens.colors.navy[800].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Light + Soft + Focus
export const ACTIVE_LIGHT_WHITE_FOCUS = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Light + Soft + Disabled
export const ACTIVE_LIGHT_WHITE_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Ligth + White + Default
export const ACTIVE_LIGHT_SOFT_DEFAULT = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Light + White + Hover
export const ACTIVE_LIGHT_SOFT_HOVER = {
    background: tokens.colors.navy[900].value,
    border: tokens.colors.navy[900].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Light + White + Pressed
export const ACTIVE_LIGHT_SOFT_PRESSED = {
    background: tokens.colors.navy[800].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Light + White + Focus
export const ACTIVE_LIGHT_SOFT_FOCUS = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Light + White + Disabled
export const ACTIVE_LIGHT_SOFT_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + Ghost + Default
export const ACTIVE_LIGHT_GHOST_DEFAULT = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Light + Ghost + Hover
export const ACTIVE_LIGHT_GHOST_HOVER = {
    background: tokens.colors.navy[900].value,
    border: tokens.colors.navy[900].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Light + Ghost + Pressed
export const ACTIVE_LIGHT_GHOST_PRESSED = {
    background: tokens.colors.navy[800].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Light + Ghost + Focus
export const ACTIVE_LIGHT_GHOST_FOCUS = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Light + Ghost + Disabled
export const ACTIVE_LIGHT_GHOST_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Light + Bare + Default
export const ACTIVE_LIGHT_BARE_DEFAULT = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Light + Bare + Hover
export const ACTIVE_LIGHT_BARE_HOVER = {
    background: tokens.colors.navy[900].value,
    border: tokens.colors.navy[900].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Light + Bare + Pressed
export const ACTIVE_LIGHT_BARE_PRESSED = {
    background: tokens.colors.navy[800].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Light + Bare + Focus
export const ACTIVE_LIGHT_BARE_FOCUS = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Light + Bare + Disabled
export const ACTIVE_LIGHT_BARE_DISABLED = {
    background: tokens.colors.midnight[150].value,
    border: tokens.colors.midnight[200].value,
    foregroundAlt: tokens.colors.midnight[200].value,
    foreground: tokens.colors.midnight[200].value
};
// Mode: Dark
// -----------------------------------------------------------------------------
// Dark + Hard + Default
export const ACTIVE_DARK_HARD_DEFAULT = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.active[100].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Dark + Hard + Hover
export const ACTIVE_DARK_HARD_HOVER = {
    background: tokens.colors.navy[900].value,
    border: tokens.colors.navy[900].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Dark + Hard + Pressed
export const ACTIVE_DARK_HARD_PRESSED = {
    background: tokens.colors.navy[800].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Dark + Hard + Focus
export const ACTIVE_DARK_HARD_FOCUS = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Dark + Hard + Disabled
export const ACTIVE_DARK_HARD_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[850].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + Soft + Default
export const ACTIVE_DARK_SOFT_DEFAULT = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Dark + Soft + Hover
export const ACTIVE_DARK_SOFT_HOVER = {
    background: tokens.colors.navy[900].value,
    border: tokens.colors.navy[900].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Dark + Soft + Pressed
export const ACTIVE_DARK_SOFT_PRESSED = {
    background: tokens.colors.navy[800].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Dark + Soft + Focus
export const ACTIVE_DARK_SOFT_FOCUS = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Dark + Soft + Disabled
export const ACTIVE_DARK_SOFT_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[850].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + White + Default
export const ACTIVE_DARK_WHITE_DEFAULT = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Dark + White + Hover
export const ACTIVE_DARK_WHITE_HOVER = {
    background: tokens.colors.navy[900].value,
    border: tokens.colors.navy[900].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Dark + White + Pressed
export const ACTIVE_DARK_WHITE_PRESSED = {
    background: tokens.colors.navy[800].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Dark + White + Focus
export const ACTIVE_DARK_WHITE_FOCUS = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Dark + White + Disabled
export const ACTIVE_DARK_WHITE_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[850].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + Ghost + Default
export const ACTIVE_DARK_GHOST_DEFAULT = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Dark + Ghost + Hover
export const ACTIVE_DARK_GHOST_HOVER = {
    background: tokens.colors.navy[900].value,
    border: tokens.colors.navy[900].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Dark + Ghost + Pressed
export const ACTIVE_DARK_GHOST_PRESSED = {
    background: tokens.colors.navy[800].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Dark + Ghost + Focus
export const ACTIVE_DARK_GHOST_FOCUS = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Dark + Ghost + Disabled
export const ACTIVE_DARK_GHOST_DISABLED = {
    background: tokens.colors.midnight[850].value,
    border: tokens.colors.midnight[850].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Dark + Bare + Default
export const ACTIVE_DARK_BARE_DEFAULT = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Dark + Bare + Hover
export const ACTIVE_DARK_BARE_HOVER = {
    background: tokens.colors.navy[900].value,
    border: tokens.colors.navy[900].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Dark + Bare + Pressed
export const ACTIVE_DARK_BARE_PRESSED = {
    background: tokens.colors.navy[800].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.active[100].value,
    foreground: tokens.colors.active[100].value
};
// Dark + Bare + Focus
export const ACTIVE_DARK_BARE_FOCUS = {
    background: tokens.colors.active[100].value,
    border: tokens.colors.navy[800].value,
    foregroundAlt: tokens.colors.navy[800].value,
    foreground: tokens.colors.navy[800].value
};
// Dark + Bare + Disabled
export const ACTIVE_DARK_BARE_DISABLED = {
    background: tokens.colors.black[100].value,
    border: tokens.colors.black[100].value,
    foregroundAlt: tokens.colors.midnight[800].value,
    foreground: tokens.colors.midnight[800].value
};
// Scheme construction - Do not touch!
// -----------------------------------------------------------------------------
// Light + Hard
export const ACTIVE_LIGHT_HARD = {
    default: ACTIVE_LIGHT_HARD_DEFAULT,
    disabled: ACTIVE_LIGHT_HARD_DISABLED,
    focus: ACTIVE_LIGHT_HARD_FOCUS,
    hover: ACTIVE_LIGHT_HARD_HOVER,
    pressed: ACTIVE_LIGHT_HARD_PRESSED
};
// Light + Soft
export const ACTIVE_LIGHT_SOFT = {
    default: ACTIVE_LIGHT_SOFT_DEFAULT,
    disabled: ACTIVE_LIGHT_SOFT_DISABLED,
    focus: ACTIVE_LIGHT_SOFT_FOCUS,
    hover: ACTIVE_LIGHT_SOFT_HOVER,
    pressed: ACTIVE_LIGHT_SOFT_PRESSED
};
// Light + White
export const ACTIVE_LIGHT_WHITE = {
    default: ACTIVE_LIGHT_WHITE_DEFAULT,
    disabled: ACTIVE_LIGHT_WHITE_DISABLED,
    focus: ACTIVE_LIGHT_WHITE_FOCUS,
    hover: ACTIVE_LIGHT_WHITE_HOVER,
    pressed: ACTIVE_LIGHT_WHITE_PRESSED
};
// Light + Ghost
export const ACTIVE_LIGHT_GHOST = {
    default: ACTIVE_LIGHT_GHOST_DEFAULT,
    disabled: ACTIVE_LIGHT_GHOST_DISABLED,
    focus: ACTIVE_LIGHT_GHOST_FOCUS,
    hover: ACTIVE_LIGHT_GHOST_HOVER,
    pressed: ACTIVE_LIGHT_GHOST_PRESSED
};
// Light + Bare
export const ACTIVE_LIGHT_BARE = {
    default: ACTIVE_LIGHT_BARE_DEFAULT,
    disabled: ACTIVE_LIGHT_BARE_DISABLED,
    focus: ACTIVE_LIGHT_BARE_FOCUS,
    hover: ACTIVE_LIGHT_BARE_HOVER,
    pressed: ACTIVE_LIGHT_BARE_PRESSED
};
// Dark + Hard
export const ACTIVE_DARK_HARD = {
    default: ACTIVE_DARK_HARD_DEFAULT,
    disabled: ACTIVE_DARK_HARD_DISABLED,
    focus: ACTIVE_DARK_HARD_FOCUS,
    hover: ACTIVE_DARK_HARD_HOVER,
    pressed: ACTIVE_DARK_HARD_PRESSED
};
// Dark + Soft
export const ACTIVE_DARK_SOFT = {
    default: ACTIVE_DARK_SOFT_DEFAULT,
    disabled: ACTIVE_DARK_SOFT_DISABLED,
    focus: ACTIVE_DARK_SOFT_FOCUS,
    hover: ACTIVE_DARK_SOFT_HOVER,
    pressed: ACTIVE_DARK_SOFT_PRESSED
};
// Dark + White
export const ACTIVE_DARK_WHITE = {
    default: ACTIVE_DARK_WHITE_DEFAULT,
    disabled: ACTIVE_DARK_WHITE_DISABLED,
    focus: ACTIVE_DARK_WHITE_FOCUS,
    hover: ACTIVE_DARK_WHITE_HOVER,
    pressed: ACTIVE_DARK_WHITE_PRESSED
};
// Dark + Ghost
export const ACTIVE_DARK_GHOST = {
    default: ACTIVE_DARK_GHOST_DEFAULT,
    disabled: ACTIVE_DARK_GHOST_DISABLED,
    focus: ACTIVE_DARK_GHOST_FOCUS,
    hover: ACTIVE_DARK_GHOST_HOVER,
    pressed: ACTIVE_DARK_GHOST_PRESSED
};
// Dark + Bare
export const ACTIVE_DARK_BARE = {
    default: ACTIVE_DARK_BARE_DEFAULT,
    disabled: ACTIVE_DARK_BARE_DISABLED,
    focus: ACTIVE_DARK_BARE_FOCUS,
    hover: ACTIVE_DARK_BARE_HOVER,
    pressed: ACTIVE_DARK_BARE_PRESSED
};
// Light
export const ACTIVE_LIGHT = {
    bare: ACTIVE_LIGHT_BARE,
    ghost: ACTIVE_LIGHT_GHOST,
    hard: ACTIVE_LIGHT_HARD,
    soft: ACTIVE_LIGHT_SOFT,
    white: ACTIVE_LIGHT_WHITE
};
// Dark
export const ACTIVE_DARK = {
    bare: ACTIVE_DARK_BARE,
    ghost: ACTIVE_DARK_GHOST,
    hard: ACTIVE_DARK_HARD,
    soft: ACTIVE_DARK_SOFT,
    white: ACTIVE_DARK_WHITE
};
// Color schema
const ACTIVE = {
    dark: ACTIVE_DARK,
    light: ACTIVE_LIGHT
};
export default ACTIVE;
//# sourceMappingURL=palette.schema.active.js.map